import { z } from "zod";
import { entitySchema, nanoidSchema } from "../utility/index.js";
const publishRecordSchema = entitySchema.extend({
  projectUid: nanoidSchema,
  status: z.union([
    z.literal("pending"),
    z.literal("building"),
    z.literal("deployed"),
    z.literal("inactive"),
    z.literal("error"),
    z.literal("deleted")
  ]),
  message: z.string().default(""),
  domain: z.string().default("")
});
export {
  publishRecordSchema
};
//# sourceMappingURL=publish.js.map
